import HTTPService from "@/services/http_service.js";

export default class ProntuarioService extends HTTPService {
  static build() {
    return new ProntuarioService();
  }

  async pdfProntuariosbyPaciente(pacienteId) {
    return await this.get(`relatorio/PDF/Prontuarios/${pacienteId}`).then(
      (resp) => {
        console.log("rest", resp);
        if (resp.status != 200) return resp;
        return resp.blob();
      }
    );
  }
}
